import { standardBorder } from "./CommonStyles";
import { style, Styles } from "./styling";

export let topDivider = divider('divider-top', {
    top: 0,
    left: 0,
    width: '100%',
    borderTop: standardBorder()
});

export let bottomDivider = divider('divider-bottom', {
    bottom: 0,
    left: 0,
    width: '100%',
    borderBottom: standardBorder()
});

export let leftDivider = divider('divider-left', {
    top: 0,
    left: 0,
    height: '100%',
    borderRight: standardBorder()
});

export let rightDivider = divider('divider-right', {
    top: 0,
    right: 0,
    height: '100%',
    borderRight: standardBorder()
});

function divider(name: string, sideStyles: Styles) {
    return style(name, {
        position: 'relative',
        '::after': {
            content: '""',
            position: 'absolute',
            ...sideStyles
        }
    });
}